const LANG = document.documentElement.getAttribute("lang");
const jobLinkText = LANG === "de" ? "Zum Jobangebot" : "To Job Offer";

let experiencLevelSelectElValue = "";
let departmentSelectElValue = "";
let locationSelectElValue = "";
let workTimeSelectElValue = "";
let jobSearchQueryValue = "";


const debounce = (func, wait, immediate) => {
    let timeout

    return function () {
        const context = this, args = arguments
        const later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

export function smartRecruiters() {
    const jobSearchElement = document.querySelector(".pul-job-search");

    if (jobSearchElement) {
        const BASE_URL = jobSearchElement.getAttribute("data-job-api");
        const resultLengthEl = jobSearchElement.querySelector(".result-number");
        const resultTextSingle = jobSearchElement.querySelector(".result-text-single");
        const resultTextMultiple = jobSearchElement.querySelector(".result-text-multiple");
        const jobsResultsEl = jobSearchElement.querySelector("#job-search-results");
        const loader = jobSearchElement.querySelector(".loader");

        const searchInputEl = jobSearchElement.querySelector("#search-job");
        const experiencLevelSelectEl = jobSearchElement.querySelector("#job-level");
        const departmentSelectEl = jobSearchElement.querySelector("#job-department");
        const locationSelectEl = jobSearchElement.querySelector("#job-location");
        const workTimeSelectEl = jobSearchElement.querySelector("#job-work-time");

        let jobsList = [];

        const searchParams = new URLSearchParams(window.location.search);

        // add query parameter
        searchParams.set('languageCode', LANG);
        setQueryParams(searchParams);

        const urlParams = window.location.href.split("?")[1];

        async function fetchJobs() {
            try {
                const response = await fetch(`${BASE_URL}?${urlParams}`);
                const data = await response.json()

                // Set lenght of jobs
                resultLengthEl.textContent = data.length;
                
                // Show correct text content based on results length
                if(data.length == 1) {
                    resultTextMultiple.style.display = 'none';
                    resultTextSingle.style.display = 'inline';
                }

                // fill jobsList array with jobs;
                jobsList = [...data];

                // Loop through jobList and append jobElement to jobsResultEl
                renderJob(jobsList, jobsResultsEl, loader)

                // hide loader
                loader.classList.add("hidden");
            } catch (error) {
                console.log(error)
            }
        }

        async function fetchExperienceLevel() {
            try {
                const response = await fetch(`${BASE_URL}/experience-levels?languageCode=${LANG}`);
                const data = await response.json();

                for (const expLevel of data) {
                    const optionElement = document.createElement("option");
                    optionElement.setAttribute("value", `${expLevel.Id}`)
                    optionElement.textContent = expLevel.Label;

                    experiencLevelSelectEl.appendChild(optionElement);
                }

                // preselect value if query param exists
                if (searchParams.get("experienceLevelId")) {
                    experiencLevelSelectEl.value = searchParams.get("experienceLevelId");
                }
            } catch (error) {
                console.log(error)
            }
        }

        async function detchDepartments() {
            try {
                const response = await fetch(`${BASE_URL}/departments?languageCode=${LANG}`);
                const data = await response.json();

                for (const department of data) {
                    const optionElement = document.createElement("option");
                    optionElement.setAttribute("value", `${department.Id}`)
                    optionElement.textContent = department.Label;

                    departmentSelectEl.appendChild(optionElement);
                }

                // preselect value if query param exists
                if (searchParams.get("departmentId")) {
                    departmentSelectEl.value = searchParams.get("departmentId");
                }
            } catch (error) {
                console.log(error)
            }
        }

        async function fetchLocation() {
            try {
                const response = await fetch(`${BASE_URL}/locations?languageCode=${LANG}`);
                const data = await response.json();

                for (const location of data) {
                    const optionElement = document.createElement("option");
                    optionElement.setAttribute("value", `${location.City}`)
                    optionElement.textContent = location.City;

                    locationSelectEl.appendChild(optionElement);
                }

                // preselect value if query param exists
                if (searchParams.get("city")) {
                    locationSelectEl.value = searchParams.get("city");
                }
            } catch (error) {
                console.log(error)
            }
        }

        async function fetchWorkingTime() {
            try {
                const response = await fetch(`${BASE_URL}/types-of-employment?languageCode=${LANG}`);
                const data = await response.json();

                for (const workingTime of data) {
                    const optionElement = document.createElement("option");
                    optionElement.setAttribute("value", `${workingTime.Id}`)
                    optionElement.textContent = workingTime.Label;

                    workTimeSelectEl.appendChild(optionElement);
                }
                // preselect value if query param exists
                if (searchParams.get("typeOfEmploymentId")) {
                    workTimeSelectEl.value = searchParams.get("typeOfEmploymentId");
                }
            } catch (error) {
                console.log(error)
            }
        }

        // fill search query from url parameter
        if (searchParams.get("query")) {
            searchInputEl.value = searchParams.get("query");
        }

        // Filter by query
        searchInputEl.addEventListener("input", debounce(() => {
            // show loader
            loader.classList.remove("hidden");

            jobSearchQueryValue = searchInputEl.value;

            // add/remove query parameter
            if (jobSearchQueryValue === "") {
                searchParams.delete("query");
                setQueryParams(searchParams)
            } else {
                searchParams.set('query', jobSearchQueryValue);
                setQueryParams(searchParams);
            }

            fetchFilteredJobs(BASE_URL, jobsResultsEl, resultLengthEl, loader, resultTextMultiple, resultTextSingle);
        }, 300));

        // Filter by experience level
        experiencLevelSelectEl.addEventListener("change", () => {
            // show loader
            loader.classList.remove("hidden");

            experiencLevelSelectElValue = experiencLevelSelectEl.value;

            // add/remove query parameter
            if (experiencLevelSelectElValue === "") {
                searchParams.delete("experienceLevelId")
                setQueryParams(searchParams)
            } else {
                searchParams.set('experienceLevelId', experiencLevelSelectElValue);
                setQueryParams(searchParams)
            }

            fetchFilteredJobs(BASE_URL, jobsResultsEl, resultLengthEl, loader, resultTextMultiple, resultTextSingle);
        });

        // Filter by department
        departmentSelectEl.addEventListener("change", () => {
            // show loader
            loader.classList.remove("hidden");

            departmentSelectElValue = departmentSelectEl.value;

            // add/remove query parameter
            if (departmentSelectElValue === "") {
                searchParams.delete("departmentId");
                setQueryParams(searchParams);
            } else {
                searchParams.set('departmentId', departmentSelectElValue);
                setQueryParams(searchParams);
            }

            fetchFilteredJobs(BASE_URL, jobsResultsEl, resultLengthEl, loader, resultTextMultiple, resultTextSingle);
        });

        // Filter by city
        locationSelectEl.addEventListener("change", () => {
            // show loader
            loader.classList.remove("hidden");

            locationSelectElValue = locationSelectEl.value;

            // add/remove query parameter
            if (locationSelectElValue === "") {
                searchParams.delete("city");
                setQueryParams(searchParams);
            } else {
                searchParams.set('city', locationSelectElValue);
                setQueryParams(searchParams);
            }

            fetchFilteredJobs(BASE_URL, jobsResultsEl, resultLengthEl, loader, resultTextMultiple, resultTextSingle);
        });

        // filter by work time
        workTimeSelectEl.addEventListener("change", () => {
            // show loader
            loader.classList.remove("hidden");

            workTimeSelectElValue = workTimeSelectEl.value;

            // add/remove query parameter
            if (workTimeSelectElValue === "") {
                searchParams.delete("typeOfEmploymentId");
                setQueryParams(searchParams);
            } else {
                searchParams.set('typeOfEmploymentId', workTimeSelectElValue);
                setQueryParams(searchParams);
            }


            fetchFilteredJobs(BASE_URL, jobsResultsEl, resultLengthEl, loader, resultTextMultiple, resultTextSingle);
        });

        fetchJobs();
        fetchExperienceLevel();
        detchDepartments();
        fetchWorkingTime();
        fetchLocation();
    }
}

function renderJob(jobList, renderParent, loader) {
    // hide loader
    loader.classList.add("hidden");

    renderParent.innerHTML = "";

    for (const job of jobList) {
        const jobElement = document.createElement("div");
        jobElement.classList.add("pul-similar-jobs__job");

        jobElement.innerHTML = `
            <div>
                <h3>${job.Name}</h3>
                <div class="pul-job-tags pul-job-tags--gap-3x">
                    ${job.ExperienceLevel.Label ? `<span>${job.ExperienceLevel.Label}</span>` : ''}
                    ${job.Department.Label ? `<span>${job.Department.Label}</span>` : ''}
                    ${job.Location.City ? `<span>${job.Location.City}</span>` : ''}
                    ${job.TypeOfEmployment.Label ? `<span>${job.TypeOfEmployment.Label}</span>` : ''}
                </div>
            </div>
            <a href="${window.location.origin}${window.location.pathname}${job.DetailPagePath}" class="pul-btn-primary">
                <span>${jobLinkText}</span>
                <svg width="6" height="10" viewBox="0 0 6 10" aria-hidden="true">
                    <use href="/ResourcePackages/pfeiferlangen/assets/img/_icn/icn-right-arrow.svg#icn"></use>
                </svg>
            </a>
        `;

        renderParent.appendChild(jobElement);
    }
}

async function fetchFilteredJobs(url, renderParent, resultLengthEl, loader, resultTextMultiple, resultTextSingle) {
    const response = await fetch(`${url}?languageCode=${LANG}&experienceLevelId=${experiencLevelSelectElValue}&departmentId=${departmentSelectElValue}&city=${locationSelectElValue}&typeOfEmploymentId=${workTimeSelectElValue}&query=${jobSearchQueryValue}`);
    const data = await response.json();

    if(data.length == 1) {
        resultTextMultiple.style.display = 'none';
        resultTextSingle.style.display = 'inline';
    } else {
        resultTextMultiple.style.display = 'inline';
        resultTextSingle.style.display = 'none';
    }

    resultLengthEl.textContent = data.length;
    renderJob(data, renderParent, loader);
}

function setQueryParams(param) {
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + param.toString();
    window.history.pushState({ path: newurl }, '', newurl);
}